import { MultipePills, PillCell } from "../../Utils/DataTable/Cells";

const columnCellMap = {
  role: MultipePills,
  status: PillCell
}

export default columnCellMap;